import { ptr } from '#styles.utils';

import { Table, Typography } from '#ui-kit';
import {
  TableCellAlign,
  TypographySize,
  TypographyTag,
  TypographyWeight,
} from '#ui-kit.types';

import { StatusBadge } from '#components';
import { notAvailableValue, prettifyDate } from '#utils';
import { OrderPOSStatusEnum } from '#services/orders/enums/order-pos-status.enum';
import { OrderStatusCommentType } from '#services/orders/responses/order.response';

import * as Styled from './style';
import { OrderPOSStatusBadgeMap } from 'pages/Order/constants';

type ViewProps = {
  data: OrderStatusCommentType[];
};

const OrderStatusComments: React.FC<ViewProps> = ({ data }) => (
  <>
    <Typography
      size={TypographySize.xl}
      tag={TypographyTag.span}
      style={{ marginBottom: ptr(20) }}
    >
      Комментарии к статусам
    </Typography>
    <Table
      {...{
        // loading,
        header: {
          cells: {},
        },
        rows: data.map((comment) => ({
          cells: {
            0: {
              width: 232,
              align: TableCellAlign.Left,
              onClick: () => {},
              children: (
                <Styled.OrderStatusContainer>
                  <StatusBadge<typeof OrderPOSStatusEnum>
                    {...{
                      value: comment.status,
                      data: OrderPOSStatusBadgeMap,
                    }}
                  />
                </Styled.OrderStatusContainer>
              ),
            },
            1: {
              width: 232,
              align: TableCellAlign.Left,
              onClick: () => {},
              children: (
                <Typography
                  size={TypographySize.m}
                  tag={TypographyTag.span}
                  weight={TypographyWeight.Medium}
                >
                  {notAvailableValue(comment.comment)}
                </Typography>
              ),
            },
            2: {
              width: 232,
              align: TableCellAlign.Left,
              onClick: () => {},
              children: (
                <Typography
                  size={TypographySize.m}
                  tag={TypographyTag.span}
                  weight={TypographyWeight.Medium}
                >
                  {comment.createdAt
                    ? prettifyDate(comment.createdAt)
                    : notAvailableValue(comment.createdAt)}
                </Typography>
              ),
            },
          },
        })),
      }}
    />
  </>
);

export default OrderStatusComments;
